import { createContext } from 'react';
import {
  type EditorPortfolioTemplates,
  type SetComplexImmerStateAction,
} from '@/lib/types';

const EditorPortfolioTemplatesContext = createContext<
  [
    EditorPortfolioTemplates,
    SetComplexImmerStateAction<EditorPortfolioTemplates>,
  ]
>([null as unknown as EditorPortfolioTemplates, () => {}]);

export default EditorPortfolioTemplatesContext;
